window.addEventListener('load', () => {
  const buttons = document.querySelectorAll('.vp-popup-media-trigger');

  if (!buttons.length) return;

  /** @type {HTMLElement | null} */
  const parent = /** @type {HTMLElement | null} */ (buttons[0].parentElement);

  if (!parent) return;

  // add styles dynamically to parent
  parent.classList.add('vp-popup-media-trigger-parent');

  // scroll 2nd button into center without vertical page jump
  if (buttons[1]) {
    /** @type {HTMLElement} */
    const button = /** @type {HTMLElement} */ (buttons[1]);
    // Calculate the centered position relative to the parent scroll container
    parent.scrollLeft = button.offsetLeft - (parent.clientWidth / 2) + (button.clientWidth / 2);
  }
});